import { render, staticRenderFns } from "./ConfirmDeleteModal.vue?vue&type=template&id=8945a9fe&"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports